'use client';

import { Box } from '@terra/ui-styled-system';
import { LineChart } from '@terra/ui-charts';
import { Activity01Icon } from '@terra/ui-icons';
import { DashboardWidget } from '../../dashboard/DashboardWidget';
import { NoData } from '../../dashboard/NoData';

type SignalsTrendWidgetProps = {
  title?: string;
  dailyCounts: Array<{
    date: string;
    count: number;
  }>;
  isLoading?: boolean;
  chartHeight?: number;
};

export function SignalsTrendWidget({
  title = 'Signals Trend',
  dailyCounts,
  isLoading = false,
  chartHeight = 200,
}: SignalsTrendWidgetProps) {
  const hasData = dailyCounts.some((entry) => entry.count > 0);
  const categories = dailyCounts.map((entry) => entry.date);
  const seriesData = dailyCounts.map((entry) => entry.count);

  return (
    <DashboardWidget
      title={title}
      icon={Activity01Icon}
      isLoading={isLoading}
      isEmpty={!isLoading && !hasData}
      contentHeight={chartHeight}
    >
      {hasData ? (
        <Box w="full">
          <LineChart
            series={[{ name: 'Signals', data: seriesData }]}
            categories={categories}
            height={chartHeight}
            showLegend={false}
            curve="smooth"
            hideOverlappingXAxisLabels
          />
        </Box>
      ) : (
        <NoData
          title="No signal activity"
          description="Signals will appear here once discovered"
        />
      )}
    </DashboardWidget>
  );
}
